'use client';

import { cn } from '@/lib/cn';

type LegendProps = React.ComponentProps<'legend'>;

function Legend({ className, ref, ...props }: LegendProps) {
  return (
    <legend
      ref={ref}
      className={cn(
        '-ml-1 px-1 text-sm font-medium whitespace-nowrap',
        className
      )}
      {...props}
    />
  );
}

export { Legend };
